const topics = [
  { name: '每日黑料', heat: '9.8万', hot: true },
  { name: '娱乐圈揭秘', heat: '8.2万', hot: true },
  { name: '社会热点', heat: '7.5万', hot: true },
  { name: '历史回顾', heat: '6.9万', hot: false },
  { name: '科技数码', heat: '5.8万', hot: false },
  { name: '生活百科', heat: '5.3万', hot: false },
  { name: '财经内幕', heat: '4.9万', hot: false },
  { name: '体坛风云', heat: '4.6万', hot: false },
  { name: '国际瞭望', heat: '4.1万', hot: false },
  { name: '深夜话题', heat: '3.8万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          热门话题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          实时热度 · 持续更新
        </p>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              {t.name}
              <span className={`text-xs ${t.hot ? 'text-accent-500' : 'text-foreground-400'}`}>
                {t.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}